/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationRelationUnlinkChildPathParams,
	OrganisationRelationUnlinkChildResponse,
} from '../types/OrganisationRelationUnlinkChild'

/**
 * DELETE /organisations/:organisation/children/:child
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationRelationController.php OrganisationRelationController::unlinkChild
 */
export async function organisationRelationUnlinkChild(
	organisation: OrganisationRelationUnlinkChildPathParams['organisation'],
	child: OrganisationRelationUnlinkChildPathParams['child'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationRelationUnlinkChildResponse>> {
	return axiosInstance.delete(`/organisations/${organisation}/children/${child}`, config)
}
